module.exports = __webpack_public_path__ + "media/images/vynil-c509c35a0be9dce00f061e5a97cb7459.png";